module.exports = __webpack_public_path__ + "img/iraq.70693ed.webp";